"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalDriversTraitColors = exports.naturalTendenciesTraitColors = void 0;
var colors = _interopRequireWildcard(require("wnd-themes/lib/colorPalette"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// TODO: Move these to the theme or some other globally accessible place
const naturalTendenciesTraitColors = exports.naturalTendenciesTraitColors = [{
  textColor: colors.white,
  primaryColor: colors.violet,
  accentColor: colors.violetAccent
}, {
  textColor: colors.white,
  primaryColor: colors.blue,
  accentColor: colors.blueAccent
}, {
  textColor: colors.black,
  primaryColor: colors.sea,
  accentColor: colors.seaAccent
}, {
  textColor: colors.black,
  primaryColor: colors.aqua,
  accentColor: colors.aquaAccent
}, {
  textColor: colors.black,
  primaryColor: colors.green,
  accentColor: colors.greenAccent
}];
const personalDriversTraitColors = exports.personalDriversTraitColors = [{
  textColor: colors.white,
  primaryColor: colors.purple,
  accentColor: colors.purpleAccent
}, {
  textColor: colors.white,
  primaryColor: colors.violet,
  accentColor: colors.violetAccent
}, {
  textColor: colors.white,
  primaryColor: colors.blue,
  accentColor: colors.blueAccent
}, {
  textColor: colors.black,
  primaryColor: colors.sea,
  accentColor: colors.seaAccent
}, {
  textColor: colors.black,
  primaryColor: colors.aqua,
  accentColor: colors.aquaAccent
}, {
  textColor: colors.black,
  primaryColor: colors.green,
  accentColor: colors.greenAccent
}];